import Homepage from './pages/Homepage/Homepage.js';
import './App.css';

function App() {
    return (
        <div className="App">
            <header className="App-header">
                <Homepage />
            </header>
        </div>
    );
}

export default App;
